import { render } from "./ParametrosView.vue?vue&type=template&id=d6a98456"
import script from "./ParametrosView.vue?vue&type=script&lang=js"
export * from "./ParametrosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__